import { render, staticRenderFns } from "./rtohandover.vue?vue&type=template&id=16daeb2a"
import script from "./rtohandover.vue?vue&type=script&lang=js"
export * from "./rtohandover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports